import { useState } from "react";

export const useLoadingState = () => {
  const [loading, setLoading] = useState(true);

  return {
    loading,
    setLoading,
  };
};
